<template>
    <div class="approval_center_wrap">
        <div class="drawer_body approval_center_wrap"  v-loading="loading">
            <div class="approval_center_detail" >
                <div class="approval_center_detail_top">
                    <div class="title_id_print_info">
                        <div class="title_info">
                            <h5>{{approvalDetailInfo &&approvalDetailInfo.approval_set &&approvalDetailInfo.approval_set.name }}
                            </h5>
                            <span :class="'approval_status_' + approvalDetailInfo.approval_status">{{getApprovalStatusText(approvalDetailInfo.approval_status)}}</span>
                        </div>
                        <div class="id_print_info">
                            <span class="id">ID:{{ approvalDetailInfo.approval_id }}</span>
                        </div>
                    </div>

                    <div class="user_time_handle_info">
                        <div class="user_time_info">
                            <userDetailPopover v-if="approvalDetailInfo.creator_info"
                                               :uid="approvalDetailInfo.creator_info.id">
                                <div slot="container">
                                    <div class="user_info ellipsis">
                                        <img :src="approvalDetailInfo && approvalDetailInfo.creator_info &&   approvalDetailInfo.creator_info.avatar  ? approvalDetailInfo.creator_info.avatar  : defaultImg"
                                             alt=""/>
                                        <span class="ellipsis">{{
                                                approvalDetailInfo && approvalDetailInfo.creator_info ? approvalDetailInfo && approvalDetailInfo.creator_info.name : ""
                                            }}</span>
                                    </div>
                                </div>
                            </userDetailPopover>

                            <div class="time_info ellipsis">
                                <span>申请时间：</span>{{ approvalDetailInfo && approvalDetailInfo.created_at }}
                            </div>
                        </div>

                    </div>

                </div>
                <div class="approval_center_detail_wrap" ref="approval_center_detail_wrap">
                    <div class="approval_center_detail_title_wrap"><span>审批详情</span></div>
                    <div class="approval_center_detail_detail" ref="anchor1">
                        <CustomFormDetailPc
                                v-if="dataLoaded"
                                ref="customFormPc"
                                :field_list="formInfoList"
                                :form_detail="formData"
                                :is_edit_mode="false"
                                :pk_id="approvalDetailInfo.approval_id"
                                :business_data="business_data"
                                :node_list="approver_list"/>
                        <!--系统审批详情-->
                        <SystemApprovalDetail
                                v-if="approvalDetailInfo && approvalDetailInfo.approval_content && approvalDetailInfo.approval_content.content &&  approvalDetailInfo.approval_content.content.details"
                                :form_detail="approvalDetailInfo.approval_content.content.details"
                                :business_data="approvalDetailInfo.approval_content.content.business_data"
                                :approval_type="approvalDetailInfo.approval_type"
                                :approvalDetailInfo="approvalDetailInfo"
                        />
                    </div>
                    <div class="approval_center_detail_title_wrap"><span>审批流程</span></div>
                    <div class="approval_center_detail_process" ref="anchor2">
                        <approvalProcessDetails
                                :approvalNodeList="approvalNodeList"
                                :approvalStatus="approvalDetailInfo.approval_status"
                                @cancelAddSignSuccess="initData()"
                        ></approvalProcessDetails>
                    </div>
                    <div class="approval_center_detail_title_wrap" v-if="approveCommentList.length > 0">
                        <span>评论</span>
                    </div>
                    <div class="approval_center_detail_comment" ref="anchor3" v-show="approveCommentList.length > 0">
                        <ul>
                            <li v-for="comment in approveCommentList">
                                <div class="process_user_info_wrap">
                                    <div class="user_header_wrap">
                                        <img
                                                :src="
                                            comment.creator_info && comment.creator_info.avatar
                                                ? comment.creator_info.avatar
                                                : defaultImg
                                        "
                                                alt=""
                                                class="header_img"
                                                onerror=""
                                        />
                                    </div>
                                    <div class="user_name">{{ comment.creator_info && comment.creator_info.name }}</div>
                                    <div class="handle_time">{{ comment.created_at }}</div>
                                </div>
                                <div class="content_outer_wrap">
                                    <div class="content_inner_wrap">
                                        <p v-if="comment.content" v-html="comment.content"></p>
                                        <template v-if="comment.pic_list && comment.pic_list.length">
                                            <img
                                                    v-for="imgItem in comment.pic_list"
                                                    :src="imgItem.file_path"
                                                    class="commentImage"
                                                    @click="handleClickPreviewImg(imgItem, comment.pic_list)"
                                            />
                                        </template>
                                        <div
                                                v-if="comment.file_list && comment.file_list.length"
                                                class="upload_file_list_detail"
                                        >
                                            <div class="upload_file_item" v-for="file in comment.file_list">
                                                <div class="file_left_wrap">
                                                    <img src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                                         alt="" class="file_img"/>
                                                </div>
                                                <div class="file_info_wrap">
                                                    <p class="ellipsis">{{ file.file_name }}</p>
                                                    <span>{{ file.file_size }}</span>
                                                </div>
                                                <div class="file_right_wrap">
                                                <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                    <i class="iconfont icon-yanjing"></i>
                                                </span>
                                                    <span class="handle_icon_wrap" @click="handleClickDownloadFile(file)">
                                                    <i class="iconfont icon-daochu"></i>
                                                </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from '@/store'
import {
    approvalDetail,
    commentList,
} from "@/api";
import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc";
import commentComponent from "@/views/pc/Approve/component/commentComponent";
import approvalProcessDetails from "@/components/pComponents/approvalProcessDetails";
import SystemApprovalDetail from "@/components/pComponents/systemApprovalDetail";
import userDetailPopover from "@/components/pComponents/userDetailPopover";

export default {
    components: {
        commentComponent,
        approvalProcessDetails,
        CustomFormDetailPc,
        SystemApprovalDetail,
        userDetailPopover,
    },
    data() {
        return {
            loading:false,
            visible: false,
            btnDisabled:false,
            approvalId:0,
            processState:'awaiting_my_action',
            approvalDetailInfo: {}, // 详情
            approvalNodeList: [], // 审批流程
            approveCommentList: [], // 评论
            approveCommentCount: 0,
            formInfoList: [],
            formData: {},
            dataLoaded: false,

        };
    },
    computed: {

    },
    created() {
        this.approvalId = this.$route.query.id;
        this.processState = this.$route.query.process_state ? this.$route.query.process_state : 'awaiting_my_action';
        this.initData()
    },
    mounted() {
        document.body.style.backgroundColor = '#ffffff';
        document.body.style.overflow = 'auto';
        document.body.style.height = 'auto';
    },
    methods: {
        initData(){
            this.getApprovalDetail(this.approvalId )
        },


        // 审批详情
        getApprovalDetail(approval_id) {
            this.loading = true;
            this.dataLoaded = false;
            approvalDetail({approval_id}).then((res) => {
                if (res.code === 200) {
                    this.approvalDetailInfo = res.data || {};
                    this.approvalNodeList = res.data.node_list || [];
                    this.approver_list = res.data.node_list.filter(item => item.type === 'approval').flatMap(node => node.handle_info.map(handle => handle.uid));
                    // 查找需要操作的流程节点
                    const node_item = this.approvalDetailInfo.node_list.find((item) => item.need_operation == 1);
                    this.currentApproval = node_item || {};
                    // 审批详情
                    if (this.approvalDetailInfo.approval_content && this.approvalDetailInfo.approval_content.content && this.approvalDetailInfo.approval_content.content.custom_details) {
                        this.formInfoList = JSON.parse(JSON.stringify(this.approvalDetailInfo.approval_content.content.custom_details));
                        this.formInfoList.forEach(field => {
                            if (field.field_type === 'table') {
                                field._child = field.table_title
                            }
                        });
                        this.formData = this.getCustomFieldsData(this.formInfoList);
                        this.dataLoaded = true;
                    }
                    if (this.approvalDetailInfo.approval_content && this.approvalDetailInfo.approval_content.content && this.approvalDetailInfo.approval_content.content.business_data) {
                        this.business_data = JSON.parse(JSON.stringify(this.approvalDetailInfo.approval_content.content.business_data))
                    }
                }
                this.getCommentList();
                this.loading = false;
            });
        },

        // 获取评论列表
        getCommentList() {
            commentList({approval_id: this.approvalId}).then((res) => {
                if (res.code === 200) {
                    this.approveCommentList = res.data || [];
                    this.$nextTick(() => {
                        window.print()
                    });
                }
            });
        },
        // 审批自定义字段数据
        getCustomFieldsData(field_list) {
            // 除了待我处理的审批用当前节点的权限 ，，别的分类的审批用 包含自己的最后一个节点的权限、
            let field_auth_hide = []
            if (this.processState == 'awaiting_my_action') {
                // 字段权限隐藏
                console.log(this.currentApproval);
                field_auth_hide = this.currentApproval.field_auth ? this.currentApproval.field_auth.filter(find => find.field_auth == 3).map((item) => item.field_key) : [] // 隐藏
            } else {
                let node_list = JSON.parse(JSON.stringify(this.approvalNodeList))
                node_list.forEach((item) => {
                    let ccUids = item.cc_info.map(map => map.cc_uid)
                    let approverUids = []
                    item.handle_info.forEach((each) => {
                        if (each.approver_info) {
                            approverUids.push(each.approver_info.id)
                        }  //审批人 -- 办理人
                        if (each.forward_info) {
                            approverUids.push(each.forward_info.id)
                        } //转交人 -- 加签人
                    })
                    this.$set(item, 'all_user_ids', [...new Set([...ccUids, ...approverUids])])
                })
                let filteredNodes = node_list.filter(node => node.all_user_ids.includes(this.owner_uid));
                let lastNode = filteredNodes[filteredNodes.length - 1]; //最后一个包含自己的节点
                if(!lastNode){ //如果节点中没有自己 就是开始
                    lastNode = node_list[0];
                }
                field_auth_hide = lastNode.field_auth.filter(find => find.field_auth == 3).map((item) => item.field_key) // 隐藏
            }
            // 字段权限隐藏
            field_list = field_list.filter(item => !field_auth_hide.includes(item.field_key));
            let data = {};
            field_list.forEach((item) => {
                data[item.field_key] = item.field_value;
            });
            return data;
        },

        // 获取审批状态
        getApprovalStatusText(approval_status) {
            let text = "";
            switch (approval_status) {
                case 0:
                    text = "审批中";
                    break;
                case 1:
                    text = "已通过";
                    break;
                case 2:
                    text = "已拒绝";
                    break;
                case 3:
                    text = "已撤销";
                    break;
            }
            return text;
        },


    },
};
</script>
<style lang="scss" scoped>
@import "@/styles/approval.scss";

.approval_center_wrap{
    max-width: 800px !important;
    height: auto !important;
    background: #fff;
    //overflow: auto;
    margin: 0 auto;
    display: block !important;
    .approval_center_detail{
        width: 100% !important;
    }
}


</style>
